<template>
  <ul class="mainmenu">
    <li>
      <router-link to="/">Home</router-link>
    </li>
    <li class="has-droupdown has-menu-child-item">
      <router-link :to="{ name: 'Product', params: { category: 'all' }, query: $route.query }">
        All Products
        <Icon name="plus" class="collapse-icon plus"/>
        <Icon name="minus" class="collapse-icon minus"/>
      </router-link>
      <ul class="submenu" v-if="categories.length">
        <li v-for="category of categories" :key="category.name">
          <router-link :to="{ name: 'Product', params: { category: category.name }, query: $route.query }">{{ category.name }}</router-link>
        </li>
      </ul>
    </li>
    <li>
      <router-link to="/installation">Installation</router-link>
    </li>
    <li>
      <router-link to="/warranty">Warranty</router-link>
    </li>
    <li>
      <router-link to="/contact">Contact</router-link>
    </li>
  </ul>
</template>

<script>
import Icon from '../../icon/Icon'
import site from '@/data/site.json'

export default {
  name: 'Nav',
  components: { Icon },
  data() {
    return { categories: site.categories }
  }
}
</script>
